module.exports = __webpack_public_path__ + "static/media/ray-tracing-image-1.321ce6be.jpg";